<template>
    <div class="col-12 mt-1">
        <div class="form-group row m-b-xs">
            <div class="col max-w-20">
                <label>{{ __('lp') }}</label><br>
                <span class="product-lp">{{ humanIndex }}</span>
            </div>

            <div :class="{'has-error': hasError(`items.${itemIndex}.symbol`)}" class="max-w-120 col  p-l-5 p-r-5" v-if="isSymbolVisible == 1">
                <label>{{ __('symbol') }}{{ isRequiredDesignation('items.symbol') }}</label>
                <select2
                    :disabled="disabled"
                    :options="standardItemsOptions"
                    v-model="selectedStandardItem"
                    @change="changeNameAndJm(true)"
                    @input="emitInput('standard_item_id', $event)"
                    :settings="standardItemSettings"
                />

                <InputErrors :errors="getErrors(`items.${itemIndex}.symbol`)"/>
            </div>
            <div class="col max-w-30" v-if="!disabled && isSymbolVisible == 1 && getPermission('create_standard_item')">
                <button style="position: absolute;left: -8px;top: 16px" type="button" :data-original-title="__('add_goods_services')"  @click="addStandardItem(itemIndex)" class="add-standard-item-button btn btn-primary btn-sm m-l-xs tooltip-more"><i class="fa fa-plus"></i></button>
            </div>

            <div :class="{'has-error': hasError(`items.${itemIndex}.name`)}" class="col p-r-5">
                <InputWrapper
                    :disabled="disabled"
                    :readonly="nameAndJmDisabled"
                    :errors="getErrors(`items.${itemIndex}.name`)"
                    :label="__('good_or_service_name')"
                    :required="isRequired('items.name')"
                    :value="item.name"
                    classNames="form-control"
                    @input="emitInput('name', $event)"
                />
            </div>

            <div :class="{'has-error': hasError(`items.${itemIndex}.quantity`)}"
                 class="col text-right max-w-80 p-l-5 p-r-5">
                <InputWrapper
                    :disabled="disabled"
                    :errors="getErrors(`items.${itemIndex}.quantity`)"
                    :label="__('item_quantity')"
                    :required="isRequired('items.quantity')"
                    :value="item.quantity | money"
                    classNames="form-control text-right"
                    mask="quantity"
                    @input="emitInput('quantity', parseFloat($event))"
                />
            </div>

            <div :class="{'has-error': hasError(`items.${itemIndex}.unit`)}" class="col  max-w-80 p-l-5 p-r-5">
                <InputWrapper
                    :disabled="disabled || nameAndJmDisabled"
                    :errors="getErrors(`items.${itemIndex}.unit`)"
                    :readonly="nameAndJmDisabled"
                    :label="__('unit_of_mesure')"
                    :required="isRequired('items.unit')"
                    :value="item.unit"
                    classNames="form-control"
                    @input="emitInput('unit', $event)"
                />
            </div>

            <div :class="{'has-error': hasError(`items.${itemIndex}.price`)}"
                 class="col text-right max-w-120 p-l-5 p-r-5">
                <InputWrapper
                    :disabled="disabled"
                    :errors="getErrors(`items.${itemIndex}.price`)"
                    :label="__('price')"
                    :required="isRequired('items.price')"
                    :value="item.price | money"
                    classNames="form-control text-right"
                    mask="money"
                    @input="emitInput('price', parseFloat($event))"
                />
            </div>

            <div :class="{'has-error': hasError(`items.${itemIndex}.net_amount`)}"
                 class="col text-right max-w-120 p-l-5 p-r-5">
                <InputWrapper
                    :disabled="disabled"
                    :errors="getErrors(`items.${itemIndex}.net_amount`)"
                    :label="__('item_net_amount')"
                    :required="isRequired('items.net_amount')"
                    :value="item.net_amount | money"
                    classNames="form-control text-right"
                    disabled
                />
            </div>

            <div :class="{'has-error': hasError(`items.${itemIndex}.vat_rate`)}" class="max-w-110 col  p-l-5 p-r-5">
                <label>{{ __('item_vat_rate') }}{{ isRequiredDesignation('items.vat_rate') }}</label>
                <select2
                    :disabled="disabled"
                    :options="vatRateOptions"
                    :value="item.vat_rate"
                    @input="handleVatRateChange"
                />

                <InputErrors :errors="getErrors(`items.${itemIndex}.vat_rate`)"/>
            </div>

            <div :class="{'has-error': hasError(`items.${itemIndex}.vat_amount`)}"
                 class="max-w-120 col text-right  p-l-5 p-r-5">
                <InputWrapper
                    :disabled="disabled"
                    :errors="getErrors(`items.${itemIndex}.vat_amount`)"
                    :label="__('item_vat_amount')"
                    :required="isRequired('items.vat_amount')"
                    :value="item.vat_amount | money"
                    classNames="form-control text-right"
                    disabled
                />
            </div>

            <div :class="{'has-error': hasError(`items.${itemIndex}.gross_amount`)}"
                 class="max-w-120 col text-right  p-l-5 p-r-5">
                <InputWrapper
                    v-if="!roundingVisible"
                    :disabled="isGrossDisabled"
                    :errors="getErrors(`items.${itemIndex}.gross_amount`)"
                    :label="__('item_gross_amount')"
                    :required="isRequired('items.gross_amount')"
                    :value="item.gross_amount | money"
                    classNames="form-control text-right"
                    mask="money"
                    @input="grossAmountChange"
                />
                <RoundingInputWrapper
                    v-else
                    :disabled="isGrossDisabled"
                    :errors="getErrors(`items.${itemIndex}.gross_amount`)"
                    :label="__('item_gross_amount')"
                    :required="isRequired('items.gross_amount')"
                    :threshold="threshold"
                    :rounding="grossRounded"
                    :value="item.gross_amount | money"
                    classNames="form-control text-right"
                    @input="roundGross"
                    mask="money"
                />
            </div>

            <div class="col-md-auto table-icons" style="width: 45px">
                <label class="m-b"> </label><br>
                <a v-if="canDeleteItem && !disabled"
                   :data-original-title="__('delete')"
                   data-placement="top"
                   data-toggle="tooltip"
                   @click="removeRow">
                    <i class="fa fa-trash"></i>
                </a>
            </div>
        </div>

    </div>
</template>

<script>
import InputWrapper from "../../../form/InputWrapper";
import inputEmit from "../../../../mixins/inputEmit";
import hasTooltips from "../../../../mixins/hasTooltips";
import hasErrors from "../../../../mixins/hasErrors";
import InputErrors from "../../../form/InputErrors";
import hasRequiredFields from "../../../../mixins/hasRequiredFields";
import RoundingInputWrapper from "../../../form/RoundingInputWrapper";
import {mapGetters} from "vuex/dist/vuex.esm.browser";
import {round} from "lodash";
import hasPermissions from "../../../../mixins/hasPermissions";

export default {
    name: "ItemRow",
    components: {RoundingInputWrapper, InputErrors, InputWrapper},
    mixins: [inputEmit, hasErrors, hasTooltips, hasRequiredFields, hasPermissions],
    data() {
        return {
            grossRounded: 0,
            nameAndJmDisabled: false,
            selectedStandardItem: this.standardItemId
        };
    },
    props: {
        item: {
            type: Object,
            required: true,
        },
        itemIndex: {
            type: Number,
            required: true,
        },
        vatRates: {
            type: Array,
            default: [],
        },
        unitPriceCalculation: {
            type: Boolean,
            required: true,
        },
        canDeleteItem: {
            type: Boolean,
            required: false,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        isSymbolVisible: {
            type: Number,
            default: 0,
        },
        standardItemId: {
            type: Number,
            default: 0,
        },
        standardItems: {
            type: Array,
            default: [],
        },
    },
    methods: {
        changeNameAndJm(emit = true){
            const _this = this;
            if(this.selectedStandardItem != 0){
                let standardItemIndex = this.standardItems.findIndex(function (item){
                    return item.id == _this.selectedStandardItem;
                })
                if(emit){
                    this.item.name = this.standardItems[standardItemIndex].item_name
                    this.item.unit = this.standardItems[standardItemIndex].item_unit_of_measure
                }

                this.nameAndJmDisabled = true;
            }
            else{
                this.item.name = ''
                this.item.unit = ''
                this.nameAndJmDisabled = false;
            }
        },
        addStandardItem(parentDiv){
            this.$emit('addStandardItem', parentDiv)
        },
        handleVatRateChange(value) {
            this.$emit('selectedVatRate', parseInt(value))

        },
        grossAmountChange(value) {
            if (!this.isGrossDisabled) {
                this.emitInput('gross_amount', parseFloat(value));
                this.emitInput('vat_amount', this.itemVatAmount);
                this.$emit('itemChanged');
            }
        },
        roundGross(value) {
            const vatAmount = parseFloat((parseFloat(value) - this.itemNetAmount).toFixed(2))

            this.grossRounded = round(parseFloat(value) - this.itemGrossAmount ,2);
            this.emitInput('gross_amount', parseFloat(value))
            this.emitInput('vat_amount',vatAmount);
            this.$emit('itemChanged');
        },
        removeRow() {
            this.$emit('removeItem');
            this.clearTooltips();
        },
        updateItemValues() {
            if (this.isGrossDisabled || this.isSelectedOtherVatRate) {
                this.emitInput('gross_amount', this.itemGrossAmount);
            }
            this.emitInput('net_amount', this.itemNetAmount);
            this.emitInput('vat_amount', this.itemVatAmount);

            this.$emit('itemChanged');
            this.grossRounded = 0;
        },
        updateItemValuesPriceCalculation(){
            if(this.unitPriceCalculation && this.isSelectedOtherVatRate){
                let vatRate = this.vatRates.find(c => c.default === 1);
                if(vatRate){
                    this.emitInput('vat_rate', vatRate.id);
                    this.emitInput('gross_amount', this.itemGrossAmount);
                }
            }
            if(!this.unitPriceCalculation && this.isSelectedVatMarginRate){
                let vatRate = this.vatRates.find(c => c.default === 1);
                if(vatRate){
                    this.emitInput('vat_rate', vatRate.id);
                    this.emitInput('gross_amount', this.itemGrossAmount);
                }
            }
            this.updateItemValues()
        }
    },
    computed: {
        roundingVisible(){
            return !this.unitPriceCalculation &&  this.itemNetAmount != 0 && this.selectedVatRateRate != 0
        },
        standardItemSettings() {
            return {
                templateResult: (option) => {
                    let standardItem = this.standardItems.find(c => c.symbol == option.text);

                    if(standardItem == undefined){

                        return option.text;
                    }
                    if(['not_active'].includes(standardItem.status)){
                        return null;
                    }
                    return standardItem.symbol + ": " + standardItem.item_name;
                },
                dropdownCssClass: 'drop-128'
            };
        },
        vatRateOptions() {
            let vatRates = this.vatRates;
            if (this.unitPriceCalculation) {
                vatRates = vatRates.filter(rate => rate.status !== 'other');
            }
            if(!this.unitPriceCalculation){
                vatRates = vatRates.filter(rate =>  rate.status !== 'vat_margin');
            }

            return vatRates.map(option => ({text: option.country_iso + ": " + option.label, id: option.id}));
        },
        standardItemsOptions() {
            let standardItems = this.standardItems;
            let options = standardItems.map(option => ({text: option.symbol, id: option.id}));
            options.unshift({text: '---', id: 0});

            return options;
        },
        humanIndex() {
            return this.itemIndex + 1;
        },
        valuesToObserveChange() {
            return [
                this.item.quantity,
                this.item.price,
                this.item.vat_rate,
            ];
        },
        itemNetAmount() {
            let amount = 0;
            if (this.unitPriceCalculation) {
                amount = this.itemGrossAmount - this.itemVatAmount;
            } else {
                amount = this.item.quantity * this.item.price || 0;
            }
            return parseFloat(amount.toFixed(2));
        },
        itemGrossAmount() {
            let amount = 0;
            if (this.unitPriceCalculation) {
                amount = this.item.quantity * this.item.price || 0;
            } else if (!this.isGrossDisabled) {
                amount = this.item.gross_amount;
            } else {
                amount = this.itemNetAmount * (1 + this.selectedVatRateRate);
            }
            if(this.isSelectedOtherVatRate){
                amount = Math.max(this.itemNetAmount,this.item.gross_amount )
                this.item.gross_amount = amount
            }

            return round(round(amount, 10), 2);
        },
        itemVatAmount() {
            let amount = 0;
            if (this.unitPriceCalculation) {
                amount = this.itemGrossAmount * this.selectedVatRateRate / (1 + this.selectedVatRateRate);
            } else {
                amount = this.itemGrossAmount - this.itemNetAmount;
            }
            return parseFloat(amount.toFixed(2));
        },
        selectedVatRate() {
            return this.vatRates.find(vr => vr.id === parseInt(this.item.vat_rate)) || {};
        },
        selectedVatRateRate() {
            return (parseFloat(this.selectedVatRate.rate) / 100);
        },
        isSelectedOtherVatRate() {
            return this.selectedVatRate.status === 'other';
        },
        isSelectedVatMarginRate() {
            return this.selectedVatRate.status === 'vat_margin';
        },
        isSelectedXXVatRate() {
            return this.selectedVatRate.country_iso === 'XX';
        },
        isGrossDisabled() {
            return this.disabled || !this.isSelectedOtherVatRate || this.unitPriceCalculation;
        },
        ...mapGetters({threshold: 'getThreshold'}),
    },
    watch: {
        valuesToObserveChange: {
            deep: true,
            handler() {
                this.updateItemValues();
            },
        },
        unitPriceCalculation() {
            this.updateItemValuesPriceCalculation();
        },
    },
    mounted() {
        const _this = this;
        var urlParams = new URLSearchParams(window.location.search);
        let standardItemIndexByItemName = this.standardItems.findIndex(function(item){
            return item.id == _this.item.standard_item_id;
        })
        if(standardItemIndexByItemName >= 0){
            this.selectedStandardItem = this.standardItems[standardItemIndexByItemName].id
            this.changeNameAndJm(urlParams.has('standard_item_id') && urlParams.get('standard_item_id') == _this.item.standard_item_id )
        }
    }
};
</script>
